import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import MuxPlayer from '@mux/mux-player-react'
import { ReactElement, useState } from 'react'
import { PipelineVideo } from 'src/v3/content-pipeline/utils/course-api'

type VideoPreviewModalProps = {
  isOpen: boolean
  onClose: () => void
  video: PipelineVideo | undefined
}

export default function VideoPreviewModal({
  isOpen,
  onClose,
  video,
}: VideoPreviewModalProps): ReactElement {
  let src = video?.fileName ? video.fileName.replace('mp4', 'm3u8') : undefined
  let [videoError, setVideoError] = useState(false)

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      aria-labelledby="video-preview-title"
      maxWidth="md"
    >
      <DialogTitle
        id="video-preview-title"
        sx={{ backgroundColor: 'background.paper' }}
      >
        {video?.name ?? 'Video Preview'}
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: 'background.paper', p: 0 }}>
        {src && !videoError ? (
          <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
            <MuxPlayer
              src={src}
              title={video?.name}
              accentColor="#f9ea4f"
              primaryColor="#6694E9"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              onError={() => setVideoError(true)}
            />
          </Box>
        ) : (
          <Box
            sx={{
              position: 'relative',
              paddingTop: '56.25%',
              bgcolor: 'background.paperDark',
            }}
          >
            <Box className="absolute inset-0 flex items-center justify-center p-6">
              <Typography
                variant="body2"
                color="text.secondary"
                className="text-center"
              >
                Video is still processing. Please try again later.
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ backgroundColor: 'background.paper' }}>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
